/* Explore page related Utils */
import { getUserData } from "../utils/FirebaseUtils";
import { filterUndefinedValues } from "@markit/common.utils";

export enum TopCreators {
  ACES = "Il83DJfU9hXC0kVWGGe4c69vEv93",
  ASAPROCKY = "AnWHMOceBFMPwk5Ckj8OGtve1Ya2",
  BEAT_THE_ODDS = "cbFOARF0wMe1SzEOl8Be6AhuWA72",
  BENLANG = "7tN2nCmMJMaY99yVW8QOudiIxe52",
  BLOOMMUSIC = "r2m7DqSZSNPxU530LGtoJ1FKZFr1",
  BOSTON_NEW_TECH = "GVxwyXIQ99OnwisFHoszcQvqkXD3",
  BRI_GIGER = "0Wya40w1NUQt8qUecDoN5DFBLW63",
  CAMHOUSTON = "peFlQiDm52SX53bEojtm2u8UrRo2",
  CHAREEDA = "6I2de5hcXCTnhC88oMRGf9qskN62",
  CHARLOTTE_CITY_GUIDE = "lBwpEZrXZ4S0yjIs6veXj6YIegq2",
  CHEF_TREV = "7YEMhJVjVxYy2cq3uCaaaiFBuP43",
  CHOPSTICK_MURPHYS = "oa9HZIOiNiSPgSERLeSaLerc0Ik2",
  CLIMATE_HAVEN = "eNFqz0L6kXhsnD1U8xvoCVwfkpE2",
  COMEDY_CHURCH = "MHiWLbsnJmXDA3QqDiF0sJwR5kC3",
  COMEDY_STORE_LJ = "q1gd9G5U2BdS4jtmL191MHqU9Ap1",
  DERBYECENTER = "ck89aPlZ62WjETDMxwNFSH6yFda2",
  DJ_NAV = "hHHSPNaodJUPhX84Hc2TlqqzSqa2",
  DOPE = "IrhGqeazxuVs3JpuyPWi9qwYabL2",
  EDUCATORSVSEVERYBODY = "mFrIO73sKyXmMiNIO0bkckfYvCf2",
  ENJOY_THE_THRILL = "rF3OMoV0OONo6SyyGZ9BN9sIKSj1",
  FEVER_DREAM = "ck0zzxA0p7YxDd5Aoh7MeV3wcZi2",
  GLAM_HOSPITALITY = "qB9dhzxgPYf62LHiMQh7yhSifaX2",
  HAPPY_VALLEY_COMEDY = "2YMCnti68EMGm7nCM3EsTEwQ0eY2",
  HOPE_DEALER = "Fo5HdYJpFNMO99bBzQ96osOQpYW2",
  IMO = "ISeOpl72xVNOTSdABJDtlxXPITI3",
  INNOVATE_BU = "G3J2bdndrkQISdGz5dbqQJgUYxE2",
  JESSLYNCH = "i3BC81aMHEc50MwBGMj3y1ahh312",
  JEFF_FORRESTER = "ZPPun203YNgR1V2ml93g17lmeRn1",
  JIMMY_NGUYEN = "IzJYiTypLkOtMW3AnkMNatea53z2",
  JONATHAN = "cIDmS5PbrqeNEBQ0cRaD6QmGLbJ2",
  JONNY_BOYARSKY = "XbT53Vo3KnW96h4Ca0fi5G8nCs53",
  KEILANI_MAI_MUSIC = "st9jLjbNdfSOVhcRPZNMNPE9gkt2",
  KING_HINO = "ztfmXe4zbYeJodFlwUILRsO4T813",
  LA_EVENTS = "Invc1dY9mXNQfMlqsNE289bR0HS2",
  LAUNCH_YARD = "fLMfCVKKs0WNbVXV3eX9CXN7gOC2",
  LEADERBANK = "Bf1ZbZiSIwg8dCkqwoAOxCkzZ1F3",
  MEET_IRL_CO = "bhkqmcsRGqdvAlpXvY74FQeelhm1",
  MELANATED_COLLEGIANS = "C2PWSDNqLBWlWVmngDSQ7muPlYJ2",
  MJ_COACHING = "u9DxR7gbpJZn0qEwuaOJkYdmQ4h1",
  NARRATIVELY = "EvEg8wQFVzaOL01TmTSQHCVGpNn1",
  OLD_DIRTY_BOSTON = "AHeGiCizJtRY3de6nabBGuga9AN2",
  OLDDOMINION = "J8w5ZiWxuXhKPOf89yFoeJfXrbP2",
  OSL_FALCONS = "DE6hDXE1MxQ0tNFw88ofmiMIyz73",
  PEPPER = "AqQpsazturcdejZHbpBwlrp85Rj1",
  PICCLES = "6rrw5EQMyyM4UnnWMcmIKm1GIQu2",
  PVD_BREWING = "LFYVoOgB8ucmou52yW9M1SOzwkx1",
  RAIZ = "VZOoxscFTedJWLbILZJFpaWl0B83",
  RIES_MCQUILLAN = "qNCLsc5PgNeeDVxZtQo3DDeQxfQ2",
  ROBERT_HUGHES = "JY89qA0VosaP8gUQFVQIJ1GkoU93",
  SAT_PREP_TUTOR = "qgBPOetKxMglJzoruAbtafbV2Pt2",
  SEAAV = "pBuvcz3gobT99tfFEClz4W7qX9w2",
  SETITOFF = "ryqQPh9j6VMpyxnPGTbecJSyN6g2",
  STATECHAMPS = "aAyPdxaTWWMDR5kpj1z3o9hh34z1",
  STOOPDATING = "ID8NaVPs6ZVx4bYJnF3F0NZOUuA2",
  SYVERSEN = "ahIv2eI67dSQHqeuECTf7w82sFQ2",
  TECHSTARS_BOS = "Apr2f2tYDCbDcjnuox9713vrtmR2",
  THECOMEDYSTORE = "qQTEq6dkLtPe1HfwPCYpnS9R9h13",
  THEJOYKINDLER = "CazCF4ikb2RziSpcPxMMgj6h1382",
  THE_MONEY_COACH = "NStv4AJkLkRV69xpWwxvcurKNpg1",
  THESCARIES = "J53qOwCWSzeG2qXbjMjFmii1PA52",
  TIGS_NEIGHBORHOOD_BAR = "hIO8lx8GhQTHbmkLw4OoCkealww1",
  TITANS_TEMPLE = "8NLDFMcDZJctQQlhgm0gNJw9yMk1",
  TRAPSCARSENT = "Sfl6r7jNgCX7oraEDRs6wKrP8hr1",
  VENTURE_GUIDES = "9jUMhD2c43d30GWXnToEk2J8pph2",
  VENTURE_LANE = "GJKL4JJVJcWhBPYKv18jGDqj6p53",
  YALE_RECORDS = "zt0Xy9BD5jhKVmYBi2zxdmBrXsy2",
  WANNAGETFASTER = "DYR7ZlqrqjVaJ56SG82F5oRZf5m2",
  ZBT_TUFTS = "lJKvIHOAnwg09hGerE2pqd3ISEw1",
}

export const ExploreTopCreators = [
  TopCreators.WANNAGETFASTER,
  TopCreators.ASAPROCKY,
  TopCreators.THECOMEDYSTORE,
  TopCreators.STOOPDATING,
  TopCreators.SEAAV,
  TopCreators.THESCARIES,
];

export const ExploreTrendingCreators = [
  TopCreators.SEAAV,
  TopCreators.CHOPSTICK_MURPHYS,
  TopCreators.CHEF_TREV,
  TopCreators.ENJOY_THE_THRILL,
  TopCreators.NARRATIVELY,
  TopCreators.DOPE,
  TopCreators.IMO,
  TopCreators.INNOVATE_BU,
  TopCreators.STATECHAMPS,
  TopCreators.DERBYECENTER,
  TopCreators.YALE_RECORDS,
  TopCreators.TECHSTARS_BOS,
  TopCreators.SETITOFF,
  TopCreators.THEJOYKINDLER,
  TopCreators.CAMHOUSTON,
  TopCreators.OLD_DIRTY_BOSTON,
  TopCreators.JESSLYNCH,
  TopCreators.ACES,
];

export const ExploreTopArtists = [
  TopCreators.ASAPROCKY,
  TopCreators.OLDDOMINION,
  TopCreators.STATECHAMPS,
  TopCreators.SETITOFF,
  TopCreators.BLOOMMUSIC,
  TopCreators.PEPPER,
  TopCreators.YALE_RECORDS,
  TopCreators.KEILANI_MAI_MUSIC,
  TopCreators.ENJOY_THE_THRILL,
];

export const ExploreTopInfluencers = [
  TopCreators.SAT_PREP_TUTOR,
  TopCreators.KING_HINO,
  TopCreators.HOPE_DEALER,
  TopCreators.SEAAV,
  TopCreators.CHOPSTICK_MURPHYS,
  TopCreators.CHEF_TREV,
  TopCreators.THE_MONEY_COACH,
  TopCreators.JESSLYNCH,
  TopCreators.CHAREEDA,
  TopCreators.RAIZ,
  TopCreators.BENLANG,
  TopCreators.ROBERT_HUGHES,
  TopCreators.BRI_GIGER,
  TopCreators.JIMMY_NGUYEN,
  TopCreators.THEJOYKINDLER,
  TopCreators.RIES_MCQUILLAN,
  TopCreators.PICCLES,
  TopCreators.CHARLOTTE_CITY_GUIDE,
  TopCreators.OLD_DIRTY_BOSTON,
  TopCreators.JONNY_BOYARSKY,
];

export const ExploreTopTech = [
  TopCreators.RIES_MCQUILLAN,
  TopCreators.VENTURE_GUIDES,
  TopCreators.SYVERSEN,
  TopCreators.INNOVATE_BU,
  TopCreators.LAUNCH_YARD,
  TopCreators.DERBYECENTER,
  TopCreators.TECHSTARS_BOS,
  TopCreators.JESSLYNCH,
  TopCreators.RAIZ,
  TopCreators.JEFF_FORRESTER,
  TopCreators.BENLANG,
  TopCreators.LEADERBANK,
  TopCreators.HOPE_DEALER,
  TopCreators.CLIMATE_HAVEN,
  TopCreators.ROBERT_HUGHES,
  TopCreators.VENTURE_LANE,
  TopCreators.PICCLES,
  TopCreators.JIMMY_NGUYEN,
  TopCreators.CHAREEDA,
  TopCreators.BOSTON_NEW_TECH,
  TopCreators.JONNY_BOYARSKY,
];

export const ExploreTopEntertainment = [
  TopCreators.THECOMEDYSTORE,
  TopCreators.COMEDY_STORE_LJ,
  TopCreators.OSL_FALCONS,
  TopCreators.PVD_BREWING,
  TopCreators.ACES,
  TopCreators.LA_EVENTS,
  TopCreators.ENJOY_THE_THRILL,
  TopCreators.EDUCATORSVSEVERYBODY,
  TopCreators.MELANATED_COLLEGIANS,
  TopCreators.ZBT_TUFTS,
  TopCreators.HAPPY_VALLEY_COMEDY,
  TopCreators.IMO,
  TopCreators.CAMHOUSTON,
  TopCreators.COMEDY_CHURCH,
  TopCreators.DJ_NAV,
  TopCreators.MEET_IRL_CO,
  TopCreators.FEVER_DREAM,
  TopCreators.TRAPSCARSENT,
  TopCreators.TITANS_TEMPLE,
  TopCreators.GLAM_HOSPITALITY,
  TopCreators.TIGS_NEIGHBORHOOD_BAR,
  TopCreators.BEAT_THE_ODDS,
  TopCreators.BLOOMMUSIC,
];

// Given the list of userIds, fetch the users to display
export const fetchExploreFeaturedUsers = async (userIds: string[]) => {
  const featuredUsers = await Promise.all(
    userIds.map(async (userId) => {
      const userData = await getUserData(userId);
      return userData;
    })
  );
  return filterUndefinedValues(featuredUsers);
};
